import React from "react";
import {
  Page,
  FlexContainer,
  SecondaryButton,
  ScrollableContainer,
  AnimatedList,
} from "../components/styled";
import SwipeableTabs from "../components/shared/swipeableTabs";
import styled from "styled-components";
import TonImage from "../assets/images/logo/tokens/ton.png";
import ReferalBackground from "../assets/images/background/referralbackground.png";
import { useUserContext } from "../context/UserContext";
import { useState, useEffect } from "react";
import { formatNumber } from "../utils";
import { useBottomSheet } from "../context/BottomSheetContext";
// import WithdrawalModalContent from "../components/withdrawModalContent";
import NoDataImage from "../assets/images/noData.png";
import InviteModalContent from "../components/inviteModalContent";
import { addReferrer } from "../service/main/api";
import { useToaster } from "../hooks/useToaster";
import { useLoading } from "../context/LoadingContext";

const Referral = () => {
  const { user, fetchUser } = useUserContext();
  const [userInvites, setUserInvites] = useState([]);
  const [refCode] = useState(user?.referralCode);
  const [tonBalance, setTonBalance] = useState(0);
  const { openSheet } = useBottomSheet();
  const [referrerUserName, setReferrerUserName] = useState("");
  const { showToaster } = useToaster();
  const { setIsLoading } = useLoading();

  useEffect(() => {
    if (user?.referrals) {
      const tons = Object.values(user.referralRewards || {});
      const total = tons.reduce((a, b) => a + b, 0);
      setTonBalance(total);
      const refs = user.referrals;
      // setUserInvites(user.referrals);
      if (refs.length > 0) {
        let x = [];
        refs.forEach((ref) => {
          let i = {
            avatar: ref.telegramPhotoUri,
            name: ref.username || ref.firstName || ref.lastName || "Unknown",
            id: ref._id,
          };
          x.push(i);
        });
        setUserInvites(x);
      }
    }
  }, [user]);
  const openWithdrawModal = () => {
    openSheet({ content: <div />, title: "Withdraw" });
  };

  const handleReferrer = async () => {
    if (!referrerUserName || referrerUserName === "") {
      showToaster({ type: "error", message: "Please enter a valid username" });
      return;
    }
    setIsLoading(true);
    const res = await addReferrer({ referrer: referrerUserName });

    if (res?.success) {
      setIsLoading(false);
      showToaster({ type: "success", message: "Referrer added successfully" });
      setTimeout(async () => {
        await fetchUser();
      }, 1000);
    } else {
      setIsLoading(false);
      showToaster({ type: "error", message: res.message });
    }
  };
  return (
    <Page>
      <SwipeableTabs tabs={["Tasks", "History"]}>
        <ScrollableContainer>
          <FlexContainer flexdirection="column">
            <CardWithRibbon>
              <span>
                Every Time a Pack bought, you get
                <br />
                5%{" "}
                <span style={{ color: "#A580EA", fontStyle: "italic" }}>
                  from Friends
                </span>
              </span>
            </CardWithRibbon>
            <RibbonCardBackground
              src={ReferalBackground}
              alt="Referal Background"
            />
            <FlexContainer gap="16px">
              <CardWithTitle>
                <CardTitle>Earn TON</CardTitle>
                <CardWithTitleContent onClick={openWithdrawModal}>
                  <FlexContainer style={{ marginBottom: "14px" }} gap="8px">
                    <MainText>{formatNumber(tonBalance)}</MainText>
                    <StyledImage src={TonImage} alt="TON" />
                  </FlexContainer>
                  <StyledSecondaryButton>Withdraw</StyledSecondaryButton>
                </CardWithTitleContent>
              </CardWithTitle>
              <CardWithTitle>
                <CardTitle>FREE CARD</CardTitle>
                <CardWithTitleContent>
                  <FlexContainer style={{ marginBottom: "14px" }} gap="8px">
                    <MainText>1 Invite = 1 card</MainText>
                  </FlexContainer>
                  <StyledSecondaryButton>
                    Free Card
                    <Badge>
                      {user?.referrals?.length > 100
                        ? 100
                        : user?.referrals?.length || 0}
                    </Badge>
                  </StyledSecondaryButton>
                </CardWithTitleContent>
              </CardWithTitle>
            </FlexContainer>
            <FlexContainer style={{ gap: "16px", marginTop: "16px" }}>
              <InviteButon
                onClick={() =>
                  openSheet({
                    content: <InviteModalContent refCode={refCode} />,
                    title: "EARN TON",
                  })
                }
              >
                Invite Friends
              </InviteButon>
            </FlexContainer>
            <FlexContainer
              flexdirection="column"
              style={{
                gap: "4px",
                textAlign: "center",
                fontSize: "12px",
                color: "#ffffffa1",
              }}
            >
              <span>Total referrals: {user?.referrals?.length || 0}</span>
              <span style={{ fontStyle: "italic" }}>
                Invite more friends to earn more TON
              </span>
            </FlexContainer>
          </FlexContainer>
        </ScrollableContainer>
        <ScrollableContainer>
          <FlexContainer>
            <InvitesContainer>
              Your Referrer
              {user?.referrer ? (
                <InviteCard>
                  <Avatar src={user?.referrer?.telegramPhotoUri} />@
                  {user?.referrer?.username ||
                    user?.referrer?.firstName ||
                    user?.referrer?.lastName ||
                    "Unknown"}
                </InviteCard>
              ) : (
                <FlexContainer flexdirection="column" gap="8px">
                  <StyledImage src={NoDataImage} alt="No Data" />
                  <FlexContainer gap="8px">
                    <ReferrerInput
                      placeholder="Enter referrer's username"
                      value={referrerUserName}
                      onChange={(e) => setReferrerUserName(e.target.value)}
                    />
                    <SecondaryButton
                      style={{ width: "40%", minWidth: "112px" }}
                      onClick={handleReferrer}
                    >
                      Add Referrer
                    </SecondaryButton>
                  </FlexContainer>
                </FlexContainer>
              )}
              Your Invites
              {React.Children.toArray(
                userInvites.map((i, index) => (
                  <AnimatedList
                    style={{ animationDelay: `${index * 0.2}s`, width: "100%" }}
                  >
                    <InviteCard>
                      <Avatar src={i.avatar} />
                      <FlexContainer
                        style={{ alignItems: "flex-start" }}
                        flexdirection="column"
                        gap="8px"
                      >
                        <span
                          style={{
                            fontSize: "16px",
                            display: "flex",
                            alignItems: "center",
                          }}
                        >{`@${i.name}`}</span>
                        <FlexContainer
                          style={{ justifyContent: "flex-start" }}
                          gap="2px"
                        >
                          <img
                            style={{ width: "17px" }}
                            src={TonImage}
                            alt="TON"
                          />
                          <span style={{ fontSize: "12px" }}>
                            {user?.referralRewards
                              ? formatNumber(user.referralRewards[i.id])
                              : "0.00"}
                          </span>
                          <span style={{ fontSize: "12px", color: "#36FF44" }}>
                            +you won
                          </span>
                        </FlexContainer>
                      </FlexContainer>
                    </InviteCard>
                  </AnimatedList>
                )),
              )}
            </InvitesContainer>
          </FlexContainer>
        </ScrollableContainer>
      </SwipeableTabs>
    </Page>
  );
};
const CardWithTitle = styled.div`
  width: 100%;
  margin-bottom: 16px;
  position: relative;
  /* display: flex; */
  /* flex-direction: column;
    align-items: center;
    justify-content: center; */
`;
const CardWithTitleContent = styled.div`
  backdrop-filter: blur(52px);
  -webkit-backdrop-filter: blur(52px);
  aspect-ratio: 1.35/1;
  max-height: 138px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 18px;
  padding: 16px;
  border: 1px solid #7455bf;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.08);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  clip-path: polygon(
    0% 0%,
    20% 0%,
    20% 1%,
    80% 1%,
    80% 0%,
    100% 0%,
    100% 100%,
    0% 100%
  );
`;
const CardTitle = styled.span`
  position: absolute;
  top: 0;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 18px;
  text-transform: uppercase;
  color: #ffffff;
  text-align: center;
  z-index: 1;
  width: 100%;
  text-align: center;
`;
const StyledSecondaryButton = styled(SecondaryButton)`
  width: calc(100% - 16px);
  height: 29px;
  font-size: 12px;
  position: absolute;
  bottom: 16px;
`;
const Badge = styled.span`
  background-color: #6b48ac;
  border-radius: 100px;
  height: 18px;
  width: 23%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  margin-left: 4px;
`;
const MainText = styled.span`
  font-size: 16px;
`;
const StyledImage = styled.img`
  margin-left: 0;
`;
const CardWithRibbon = styled.div`
  width: 100%;
  aspect-ratio: 4/1;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 18px;
  padding: 16px;
  border: 1px solid #7455bf;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.08);
  backdrop-filter: blur(52px);
  position: relative;
  z-index: 1;
  font-size: 1em;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin-top: 32px;
  margin-bottom: 32px;
`;
const RibbonCardBackground = styled.img`
  position: absolute;
  left: -10%;
  width: 100%;
  height: 100%;
  z-index: 0;
  top: -15%;
  object-fit: contain;
  z-index: -1;
`;
const InviteButon = styled(SecondaryButton)`
  background: linear-gradient(
    180deg,
    #3977ad 12.44%,
    #29497c 45.28%,
    #00195c 50.97%,
    #00558b 100%
  );
  border: 1px solid #ffffff;
  backdrop-filter: blur(10.800000190734863px);
  -webkit-backdrop-filter: blur(10.800000190734863px);
  box-shadow: 0px 7px 0px 0px #003383;
  width: 100%;
  height: 60px;
  align-self: flex-end;
`;
const InvitesContainer = styled(FlexContainer)`
  background: #3434344d;
  backdrop-filter: blur(50px);
  -webkit-backdrop-filter: blur(50px);
  border-radius: 24px;
  padding: 16px;
  height: 100%;
  flex-direction: column;
  gap: 8px;
`;
const InviteCard = styled(FlexContainer)`
  height: 72px;
  border: 1px solid #7455bf;
  backdrop-filter: blur(52.70000076293945px);
  -webkit-backdrop-filter: blur(52.70000076293945px);
  border-radius: 18px;
  padding: 0 16px;
  justify-content: flex-start;
  gap: 8px;
`;
const Avatar = styled.img`
  border-radius: 50%;
  border: 2px solid white;
  aspect-ratio: 1/1;
  height: 65%;
`;
const ReferrerInput = styled.input`
  width: 100%;
  height: 40px;
  border-radius: 28px;
  border: 1px solid #7455bf;
  background: #343434;
  color: white;
  padding: 0 16px;
  font-size: 16px;
  outline: none;
`;
export default Referral;
